import { Box } from '@mui/material';
import TeamsList from 'components/featured/Team/TeamsList';
import CustomHeadline from 'components/shared/CustomHeadline/CustomHeadline';
import CustomTab from 'components/shared/CustomTab/CustomTab';
import { LayoutSwitcher } from 'components/shared/LayoutSwitcher';
import { LayoutType } from 'model/deals.model';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { DashboardService } from 'service/dashboard.service';
import { TeamService } from 'service/team.service';

type SportsProps = {
  link: '';
  title: '';
  source: '';
};
type TeamData = {
  members: [
    {
      id: string | null;
      position: string | null;
      name: string | null;
      mobile: string | null;
      phone: string | null;
      address: {
        city: string | null;
        country: string | null;
        geocodeAccuracy: string | null;
        latitude: string | null;
        longitude: string | null;
        postalCode: string | null;
        state: string | null;
        street: string | null;
      };
      company: string | null;
      email: string | null;
      openDeals: string | null;
      openTasks: string | null;
      title: string | null;
      profile_image_url: string | null;
    },
  ];
};
const Team = () => {
  const currentTeamLayoutType =
    (sessionStorage.getItem('currentTeamLayoutType') as LayoutType) || LayoutType.KANBAN;
  const [layout, setLayout] = useState<LayoutType>(currentTeamLayoutType);

  const handleLayoutChange = (_: SyntheticEvent, newValue: LayoutType) => {
    sessionStorage.setItem('currentTeamLayoutType', newValue);
    setLayout(newValue);
  };

  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [data, setData] = useState<TeamData>({
    members: [
      {
        id: '',
        position: '',
        name: '',
        mobile: '',
        phone: '',
        address: {
          city: '',
          country: '',
          geocodeAccuracy: '',
          latitude: '',
          longitude: '',
          postalCode: '',
          state: '',
          street: '',
        },
        company: '',
        email: '',
        openDeals: '',
        openTasks: '',
        title: '',
        profile_image_url: '',
      },
    ],
  });

  const [loading, setLoading] = useState(false);
  const getAllTeam = async () => {
    setLoading(true);
    try {
      const res: TeamData = await TeamService.getAllMembers();
      setData(res);
    } catch (err: any) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAllTeam();
  }, []);

  const TeamTabs = [
    {
      label: 'Members',
      id: 1,
      isHidden: false,
      Component: (
        <Box>
          <TeamsList layout={layout} category={'all'} loading={loading} data={data} />
        </Box>
      ),
    },
  ];

  const [sportsData, setSportsData] = React.useState<SportsProps[]>([
    {
      link: '',
      title: '',
      source: '',
    },
  ]);

  const getSportNews = async () => {
    try {
      const res: { latestNews: SportsProps[] } = await DashboardService.getSportNews();
      setSportsData(res?.latestNews);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getSportNews();
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Box>
        <CustomHeadline sportsData={sportsData} />
      </Box>
      <Box
        sx={{
          padding: '2rem 1.5rem 0rem 1.5rem',
          position: 'relative',
        }}
      >
        <CustomTab tabs={TeamTabs} handleChange={handleChange} value={value} />
        <Box
          sx={{
            position: 'absolute',
            top: '2rem',
            right: '1.5rem',
            display: 'flex',
            gap: '16px',
          }}
        >
          <LayoutSwitcher layout={layout} onLayoutChange={handleLayoutChange} />
        </Box>
      </Box>
    </Box>
  );
};

export default Team;
